var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "c-folder-layer" }, [
    _vm.node.type === _vm.FIG_PARSED_FIELD_TYPES.FRAME ||
    _vm.node.type === _vm.FIG_PARSED_FIELD_TYPES.CANVAS ||
    _vm.node.type === _vm.FIG_PARSED_FIELD_TYPES.TEMPLATE
      ? _c(
          "div",
          [
            _c(
              "div",
              {
                staticClass:
                  "row c-folder-layer__folder d-flex align-items-center",
              },
              [
                _c(
                  "div",
                  { staticClass: "col-9 d-flex align-items-center" },
                  [
                    _c("b-form-checkbox", {
                      staticClass: "mr-1",
                      attrs: { checked: _vm.node.data.visible },
                      on: {
                        change: function ($event) {
                          return _vm.toggleLayer(_vm.node)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "cursor-pointer",
                        on: { click: _vm.collapseHandler },
                      },
                      [
                        _c("b-icon", {
                          staticClass: "mr-2",
                          class: { closed: !_vm.visible, opened: _vm.visible },
                          attrs: { icon: "triangle-fill" },
                        }),
                        _vm._v(" "),
                        _vm.node.type === _vm.FIG_PARSED_FIELD_TYPES.CANVAS
                          ? _c("b-icon", { attrs: { icon: "file-earmark" } })
                          : _c(
                              "svg",
                              {
                                staticClass: "mr-2",
                                attrs: { width: "20", height: "20" },
                              },
                              [
                                _c("use", {
                                  attrs: {
                                    href: "/img/icons/sprite.svg#file-folder-svg",
                                  },
                                }),
                              ]
                            ),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.node.data.name) +
                            "\n        "
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c("b-collapse", { attrs: { visible: _vm.visible } }, [
              _c(
                "div",
                { staticClass: "ml-3 mb-2" },
                _vm._l(_vm.node.children, function (child) {
                  return _c(
                    "div",
                    { key: child.uuid },
                    [_c("FigmaFolderLayer", { attrs: { node: child } })],
                    1
                  )
                }),
                0
              ),
            ]),
          ],
          1
        )
      : _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass:
                "layer--item col-9 d-flex align-items-center position-relative",
            },
            [
              _c("b-form-checkbox", {
                staticClass: "mr-2",
                attrs: { checked: _vm.node.data.visible },
                on: {
                  change: function ($event) {
                    return _vm.toggleLayer(_vm.node)
                  },
                },
              }),
              _vm._v(" "),
              _c(_vm.childComponent(_vm.node), {
                tag: "component",
                attrs: { node: _vm.node },
              }),
            ],
            1
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }